import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SuperChatLoader = () => {
  const location = useLocation();
  const [chatLoaded, setChatLoaded] = useState(false);

  useEffect(() => {
    const existingScript = document.getElementById('superchat-script');

    const removeSuperChat = () => {
      if (window.Superchat && typeof window.Superchat.destroy === 'function') {
        window.Superchat.destroy();
        console.log('✅ SuperChat instance destroyed');
      }

      document.querySelectorAll('[id^="superchat"], [class*="superchat"]').forEach((el) => {
        el.remove();
      });

      setChatLoaded(false);
    };

    if (!existingScript && !chatLoaded) {
      const script = document.createElement('script');
      script.id = 'superchat-script';
      script.src = 'https://widget.superchat.de/snippet.js?applicationKey=WClo1RPmY7wBYj1ardeMpGQDL3';
      script.async = true;
      script.onload = () => {
        if (window.Superchat) {
          window.Superchat.init({
            applicationKey: 'WClo1RPmY7wBYj1ardeMpGQDL3',
          });
          console.log('✅ SuperChat initialized successfully');
          setChatLoaded(true);
        }
      };
      document.body.appendChild(script);
    }

    return () => {
      // Dacă vrei să păstrezi chatul activ permanent, nu curăța la route change
      // Dacă vrei curățare completă când utilizatorul părăsește aplicația, de-comentează:
      /*
      console.log('🧹 Cleaning up SuperChat on unmount');
      removeSuperChat();
      if (existingScript) {
        existingScript.remove();
      }
      */
    };
  }, [location]);

  return null;
};

export default SuperChatLoader;
